// src/contexts/ScratchFeatureContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from "../utils/AxiosInstance";

/**
 * Site-wide Scratch-Off Intelligence flag, read from the public
 * `GET /site/public/scratch/status` endpoint (unauthenticated — works for
 * anonymous visitors and logged-in users alike). Drives nav visibility,
 * Landing marketing content, and route access for `/scratch*` everywhere
 * except the admin panel, which always shows the feature regardless.
 */
const ScratchFeatureContext = createContext({
  scratchEnabled: false,
  loading: true,
});

export function ScratchFeatureProvider({ children }) {
  const [scratchEnabled, setScratchEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await axiosInstance.get("/site/public/scratch/status");
        if (mounted) setScratchEnabled(!!res?.data?.enabled);
      } catch {
        if (mounted) setScratchEnabled(false);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <ScratchFeatureContext.Provider value={{ scratchEnabled, loading }}>
      {children}
    </ScratchFeatureContext.Provider>
  );
}

export function useScratchFeature() {
  return useContext(ScratchFeatureContext);
}
